import { getCookies, getRole } from '@/utility/helper';
import { getRolePrefix, RoutesLink } from '@/utility/RouteLinks';
import { RootState, useAppSelector } from '@/redux/store';
import { Navigate } from 'react-router-dom';
import { useActiveRole } from '@/hooks/useActiveRole';

const ProtectedLoginRoute: React.FC<{
  element: React.ReactNode;
}> = ({ element }) => {
  const isAuthenticated = Boolean(
    getCookies(`${import.meta.env.VITE_BUSINESS}token`),
  );
  const { prefix } = useActiveRole()
  const dashboardPath = prefix + RoutesLink.dashboard;

  return !isAuthenticated ? element : <Navigate to={dashboardPath} replace />;
};
export default ProtectedLoginRoute;
